var __jsx = React.createElement;
import React from 'react';
import { useIntl } from 'react-intl';
import { EditIcon, ProductImage, ProductImageContainer, ProductInfo, ProductItem, ProductName, ProductOffer, ProductPreview, RemoveIcon } from './ProductList.style';

var ProductList = function ProductList(_ref) {
  var products = _ref.products,
      onEditProduct = _ref.onEditProduct,
      onRemoveProduct = _ref.onRemoveProduct;
  var intl = useIntl();
  return __jsx(React.Fragment, null, products.map(function (product, index) {
    var _product$image, _product$offer, _product$offer2;

    return __jsx(ProductItem, {
      key: product.productId
    }, __jsx(ProductPreview, null, __jsx(ProductImageContainer, null, __jsx(ProductImage, {
      src: (_product$image = product.image) === null || _product$image === void 0 ? void 0 : _product$image.imgUrl,
      alt: product.name,
      "aria-label": "".concat(intl.formatMessage({
        id: 'affiliation-slideshow-modal.list.preview'
      }), " - ").concat(product.name)
    })), __jsx(ProductInfo, null, __jsx(ProductName, null, product.name), __jsx(ProductOffer, null, (_product$offer = product.offer) === null || _product$offer === void 0 ? void 0 : _product$offer.storeName, " - ", (_product$offer2 = product.offer) === null || _product$offer2 === void 0 ? void 0 : _product$offer2.price, "\u20AC"))), __jsx(EditIcon, {
      onClick: function onClick() {
        return onEditProduct(index);
      },
      "aria-label": "".concat(intl.formatMessage({
        id: 'affiliation-slideshow-modal.list.edit'
      }), " - ").concat(product.name)
    }), __jsx(RemoveIcon, {
      onClick: function onClick() {
        return onRemoveProduct(index);
      },
      "aria-label": "".concat(intl.formatMessage({
        id: 'affiliation-slideshow-modal.list.remove'
      }), " - ").concat(product.name)
    }));
  }));
};

export default ProductList;